/**
 * Extracts a single cookie value from a raw cookie header string.
 * Works on both server (req.headers.cookie) and client (document.cookie).
 */
export const parseCookieValue = (
  cookieStr: string,
  name: string
): string | undefined => {
  if (!cookieStr) return undefined;
  const pair = cookieStr
    .split(";")
    .map((s) => s.trim())
    .find((s) => s.startsWith(`${name}=`));
  return pair ? pair.substring(name.length + 1) : undefined;
};
